export default "__VITE_ASSET__C2Whp5Lp__"